import AutomationCollection from "nexia_mobile/models/automation_collection";
import BaseCollection from "nexia_mobile/models/base_collection";
import BaseModel from "nexia_mobile/models/base_model";
import DeviceCollection from "nexia_mobile/models/device_collection";
import Editable from "nexia_mobile/models/mixins/editable";
import Detailsable from "nexia_mobile/models/mixins/detailsable";
import ModeCollection from "nexia_mobile/models/mode_collection";
import EventCollection from "nexia_mobile/models/event_collection";
import RecordedVideoCollection from "nexia_mobile/models/recorded_video_collection";
import MediaType from "nexia_mobile/framework/media_type";
import Dispatch from "nexia_mobile/flux_like/dispatch";

export default class Location extends BaseModel {
  nestedCollections() {
    return {
      automations: {
        collection: AutomationCollection,
      },
      devices: {
        collection: DeviceCollection,
      },
      modes: {
        collection: ModeCollection,
      },
      events: {
        collection: EventCollection,
      },
      recordedVideos: {
        collection: RecordedVideoCollection,
      },
      operations: {
        collection: BaseCollection,
        model: BaseModel,
      },
    };
  }

  constructor(...args) {
    super(...args);
    this.listenTo(this.get("modes"), "reload_automations", () => {
      return this.get("automations").fetch();
    });

    this.listenTo(this.get("devices"), "name:edited", () => {
      return this.fetch();
    });

    this.get("events").automationFilters = this.get("automations");
    this.get("events").deviceFilters = this.get("devices");
  }

  getChildSchema(schemaType, callback) {
    return this.get("devices")
      .createEditSchema()
      .then((schema) => {
        let addDeviceSchema = schema
          .getChildSchemas()
          .models.find((childSchema) =>
            childSchema.get("label").match(new RegExp(schemaType, "i"))
          );

        return addDeviceSchema.getNextStep().then(
          ({ nextSchema }) => {
            return callback(nextSchema);
          },
          () => {
            // Ignore failure to get next step
          }
        );
      });
  }

  unregisterThirdParty(href) {
    let dummyModel = new BaseModel();
    dummyModel.setUrl(href);
    dummyModel.setAsEphemeral();
    return dummyModel.destroy();
  }

  parseLinksChild(links) {
    if (links.length === 0) {
      return null;
    }
    let linkPromises = [];
    links.forEach((link) => {
      switch (link.getCollectionItemType()) {
        case MediaType.AUTOMATION:
          linkPromises.push(
            this.get("automations").set(link.getData(), {
              parse: true,
              asyncParseDelay: 1,
            })
          );
          break;
        case MediaType.DEVICE:
          linkPromises.push(
            this.get("devices").set(link.getData(), {
              parse: true,
              asyncParseDelay: 1,
            })
          );
          break;
        case MediaType.EVENT:
          this.maybeParseChildLinkForCollection(this.get("events"), link);
          break;
        case MediaType.MODE:
          this.get("modes").set(link.getData(), { parse: true });
          break;
        case MediaType.VIDEO:
          this.maybeParseChildLinkForCollection(
            this.get("recordedVideos"),
            link
          );
          break;
      }
    });

    this._asyncParsePromise = Promise.all(linkPromises).then(() => {
      this.set("hasParsedChildCollections", true);
    });
    // Only prevent this if we were explicitly told to
    if (this._allowHomeProfileUpdate !== false) {
      this._asyncParsePromise.then(() =>
        Dispatch("UPDATE_VOGNITION_HOME_PROFILE", this)
      );
    }
    return null;
  }

  parseLinksOperation(links) {
    let link = _.first(links);
    if (link == null) {
      return;
    }
    this.get("operations").add(
      new BaseModel(_.extend({}, link, link.getData()), { parse: true })
    );
  }

  ensureParsed() {
    return this._asyncParsePromise;
  }

  allowHomeProfileUpdate() {
    this._allowHomeProfileUpdate = true;
  }

  preventHomeProfileUpdate() {
    this._allowHomeProfileUpdate = false;
  }

  getDeviceListingView() {
    return this._allowDeviceListingView;
  }
  preventDeviceListingView() {
    this._allowDeviceListingView = false;
  }
  allowDeviceListingView() {
    this._allowDeviceListingView = true;
  }
}

_.extend(Location.prototype, Editable, Detailsable);



// WEBPACK FOOTER //
// ./src/models/location.js